export default "__VITE_ASSET__BWMBjDWS__"